import { Link } from "react-router-dom";
import { NAV_LINKS } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-brand-bg pb-32 pt-14 md:pb-14">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <button onClick={() => scrollToId("start")} className="flex items-center gap-2" data-testid="footer-logo">
            <img src="/brand/logo.png" alt="Kurier Connect" className="h-10 w-10 rounded-md object-contain" />
            <span className="font-heading text-base font-extrabold uppercase tracking-[0.14em] text-white">
              Kurier<span className="text-brand-green">Connect</span>
            </span>
          </button>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                className="font-body text-sm text-white/55 transition-colors hover:text-white"
                data-testid={`footer-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-2xl font-body text-xs leading-relaxed text-white/35">
            © {new Date().getFullYear()} Kurier Connect. Die Inhalte dieser Seite dienen der
            allgemeinen Information rund um das kostenlose Webinar zum Thema Fahrzeugüberführung und
            stellen keine Einkommensgarantie dar.
          </p>
          <div className="flex shrink-0 gap-6">
            <Link
              to="/impressum"
              data-testid="footer-impressum"
              className="font-body text-sm text-white/55 transition-colors hover:text-brand-green"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              data-testid="footer-datenschutz"
              className="font-body text-sm text-white/55 transition-colors hover:text-brand-green"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
